// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--eMWRA";
export var container = "footer-module--container--3anUK";
export var scrollToTop = "footer-module--scrollToTop--1OFyX";
export var contents = "footer-module--contents--29k6A";
export var nav = "footer-module--nav--3MedS";
export var socialIcons = "footer-module--socialIcons--1tY15";
export var copyright = "footer-module--copyright--30fCu";